/** Live site-map catalog for the Admin desk. Paths match the two routers. */

export const CHECKLIST_ORIGIN = "https://rechecklist.pro";
export const JOURNEY_ORIGIN = "https://dreamhomejourney.online";
export const CHECKLIST_LOCAL = "http://localhost:5173";
export const JOURNEY_LOCAL = "http://127.0.0.1:5174";

export const CROSS_LINKS = [
  {
    from: "App footer · Support",
    to: `${JOURNEY_ORIGIN}/support?role=&user=`,
    travels: "Signed-in role and user id",
  },
  {
    from: "Agent / Broker dashboards · Billing",
    to: `${JOURNEY_ORIGIN}/pay?role=&user=`,
    travels: "Same query params",
  },
  {
    from: "App footer · brand",
    to: JOURNEY_ORIGIN,
    travels: "No params",
  },
  {
    from: "Journey · Create an account",
    to: `${CHECKLIST_ORIGIN}/register`,
    travels: "—",
  },
  {
    from: "Journey Support · Open the app",
    to: `${CHECKLIST_ORIGIN}/agent/login or /broker/login`,
    travels: "Role from Support",
  },
  {
    from: "Journey Pro hub",
    to: "Agent + broker login",
    travels: "—",
  },
  {
    from: "Journey · Private beta onboarding",
    to: `${CHECKLIST_ORIGIN}/?beta=1&handoff=`,
    travels: "Signed profile + acceptance timestamp (one-time token)",
  },
  {
    from: "Journey Client hub",
    to: `${CHECKLIST_ORIGIN}/`,
    travels: "—",
  },
  {
    from: "Journey Pay (placeholder)",
    to: `${CHECKLIST_ORIGIN}/?checkout=success&role=&user=`,
    travels: "Checkout flag",
  },
  {
    from: "Hub events (Journey)",
    to: "REChecklist agent/broker calendar",
    travels: "Read-only merge; not written to dh_events",
  },
];

export const JOURNEY_NAV = {
  header: ["Home", "About", "Manuals", "Support", "Community", "Contact", "Login"],
  footer: [
    "Why DreamHomeJourney",
    "Why REChecklist",
    "Benefits",
    "Testimonials",
    "User manuals",
    "Guided Tour",
    "Sales demo",
    "FAQ",
    "Pricing",
    "Support",
    "Vendors",
    "Events",
    "Calendar",
    "Contact",
  ],
};

export const JOURNEY_ROUTES = [
  { path: "/, /sales", page: "Home / sales", notes: "Vibrant landing: marketing desk + support porch" },
  { path: "/why", page: "Why DreamHomeJourney", notes: "Marketing sibling, not a second product" },
  { path: "/why-rechecklist", page: "Why REChecklist", notes: "Desk product story" },
  { path: "/benefits/buyers|sellers|agents|brokers", page: "Role benefits", notes: "Four benefit pages" },
  { path: "/testimonials", page: "Testimonials", notes: "Placeholder quotes" },
  { path: "/guide, /guide/:slug", page: "Redirects to /manuals" },
  { path: "/manuals", page: "Manual chooser (signed-in role or admin)" },
  { path: "/manuals/:role, /manuals/:role/:slug", page: "Role manuals (buyer/seller/agent/broker) behind Journey login" },
  { path: "/pricing", page: "Pricing", notes: "Agent $29.99 · office seat tiers" },
  { path: "/pay", page: "PayPal checkout", notes: "Returns to REChecklist with checkout=success" },
  { path: "/login", page: "Journey sign-in for role manuals + doors to REChecklist desks" },
  { path: "/broker-pilot", page: "Broker pilot", notes: "Footer" },
  { path: "/faq", page: "FAQ", notes: "Footer + Support" },
  { path: "/contact", page: "Contact", notes: "Header + Support" },
  { path: "/support", page: "Support landing", notes: "Five role doors including admin" },
  { path: "/support/tour", page: "Guided Tour", notes: "Agent or broker from ?role=" },
  { path: "/demo", page: "Sales demo", notes: "Admin / Magix film; ends on REChecklist homepage" },
  { path: "/support/:role", page: "Role support", notes: "Guides, tutorials, troubleshooting, practices, links" },
  { path: "/vendors", page: "Vendor hub", notes: "/support/vendors redirects here" },
  { path: "/vendors/pro", page: "Pro directory", notes: "Search, categories, detail" },
  { path: "/vendors/client", page: "Client directory", notes: "Search, categories, detail" },
  { path: "/vendors/:id", page: "Vendor detail", notes: "Placeholder contact" },
  { path: "/community, /board", page: "Community BBS", notes: "Posts, comments, likes, posting controls" },
  { path: "/events", page: "Events", notes: "Search, filters, posting, San Diego County" },
  { path: "/events/:id", page: "Event detail", notes: "Calendar integration note" },
  { path: "/calendar", page: "Journey calendar", notes: "Same hub events as REChecklist desk calendar" },
  { path: "/pro", page: "Pro hub", notes: "Vendors/tools + office logins" },
  { path: "/clients", page: "Client hub", notes: "Education + app home" },
  { path: "/beta", page: "Beta invitation", notes: "Confidential; Begin Beta Access" },
  { path: "/beta/agreement", page: "Beta participation agreement", notes: "Click-accept + timestamp" },
  { path: "/beta/profile", page: "Beta profile", notes: "Agent/Broker → handoff to REChecklist" },
];

export const CHECKLIST_PUBLIC = [
  { path: "/", page: "Start / home", notes: "Consumes ?beta=1&handoff= and shows Beta welcome" },
  { path: "/dashboard", page: "Main Dashboard" },
  { path: "/checklist", page: "Checklist overview" },
  { path: "/login", page: "Buyer login" },
  { path: "/register", page: "Register (paid account; no trial period)" },
  { path: "/seller/login", page: "Seller login" },
  { path: "/agent/login", page: "Agent login (Journey Open the app)" },
  { path: "/broker/login", page: "Broker login" },
  { path: "/about, /contact, /privacy, /terms", page: "Legal" },
  { path: "/client", page: "Client Access (Client ID entry)" },
  { path: "/portal/access", page: "Magic-link client portal door" },
  { path: "/buyer/:clientCode, /portal/buyer/:clientCode", page: "Buyer client portal (Client ID)" },
  { path: "/seller/:clientCode, /portal/seller/:clientCode", page: "Seller client portal (Client ID)" },
  { path: "/account", page: "Professional account portal (agent/broker)" },
  { path: "/account/lifecycle…", page: "Account lifecycle (suspend, cancel, reactivate, compliance)" },
  { path: "/client/register", page: "Invite client — setup email, Client ID after they finish" },
  { path: "/invite/:token", page: "Client account setup from advisor invitation" },
  { path: "/client/:clientCode", page: "Public Client ID door → buyer or seller portal" },
  { path: "/desk/clients, /desk/clients/:clientCode", page: "Desk client list / confirm popout" },
  { path: "/notices", page: "System notices (broadcasts land here)" },
  { path: "/connect/:deskId", page: "Public prospect door (no account)" },
  { path: "/install", page: "Install instructions" },
  { path: "/manual, /manual/:role, /manual/:role/:slug", page: "Redirects to DreamHomeJourney role manuals" },
];

export const BUYER_PATH = [
  "/start",
  "/location",
  "/home-type",
  "/lot",
  "/exterior",
  "/interior",
  "/lifestyle",
  "/accessibility",
  "/notes",
  "/tips",
  "/transaction",
  "/complete",
];

export const SELLER_PATH = [
  "/seller/home",
  "/seller/welcome",
  "/seller/property-details",
  "/seller/interior-features",
  "/seller/exterior-features",
  "/seller/upgrades",
  "/seller/condition-notes",
  "/seller/photos",
  "/seller/improvements",
  "/seller/portfolio-summary",
];

export const SELLER_REDIRECTS = [
  { path: "/seller/listing-readiness", to: "/seller/improvements?panel=readiness" },
  { path: "/seller/tips", to: "/seller/improvements?panel=tips" },
  { path: "/seller/notes", to: "/seller/welcome?panel=notes" },
];

export const AGENT_ROUTES = [
  { path: "/agent/dashboard", page: "Dashboard · Billing → Journey /pay" },
  { path: "/agent/start-here", page: "New to REChecklist? Start Here." },
  { path: "/agent/clients, /agent/client/:id", page: "Client Manager" },
  { path: "/agent/prospects, /agent/prospects/:id", page: "Prospects — CRM-lite before a File" },
  { path: "/agent/files, /agent/files/:id", page: "File Packet" },
  { path: "/agent/documents", page: "Documents & photos" },
  { path: "/agent/calendar", page: "Calendar" },
  { path: "/agent/hub", page: "The Hub — Convention Hall (broker/agent BBS)" },
  { path: "/agent/messages, …/archive", page: "Client Messaging" },
  { path: "/agent/office, …/archive", page: "Office Messaging" },
  { path: "/agent/audit", page: "Retention" },
  { path: "/agent/settings", page: "Profile / settings + suggestion form" },
  { path: "/agent/responses … /summary", page: "Inquiry / response wizard" },
];

export const BROKER_ROUTES = [
  { path: "/broker/dashboard", page: "Dashboard · Billing → Journey /pay" },
  { path: "/broker/start-here", page: "New to REChecklist? Start Here." },
  { path: "/broker/clients, /broker/client/:id", page: "Client Manager" },
  { path: "/broker/prospects, /broker/prospects/:id", page: "Prospects — CRM-lite before a File" },
  { path: "/broker/files, /broker/files/:id", page: "File Packet" },
  { path: "/broker/documents", page: "Documents & photos" },
  { path: "/broker/calendar", page: "Calendar" },
  { path: "/broker/hub", page: "The Hub — Convention Hall (broker/agent BBS)" },
  { path: "/broker/messages, …/archive", page: "Client Messaging" },
  { path: "/broker/office, …/archive", page: "Office Messaging" },
  { path: "/broker/profile", page: "Broker Profile" },
  { path: "/broker/settings", page: "Settings + suggestion form" },
  { path: "/broker/audit", page: "Retention" },
  { path: "/broker/controls/agents", page: "Broker override — agent lifecycle" },
  { path: "/broker/responses … /summary", page: "Inquiry / response wizard" },
];

export const ADMIN_ROUTES = [
  { path: "/admin", page: "Dashboard · desk previews · sample reports" },
  { path: "/admin/messages, …/archive", page: "All files + broadcast, follow-up, guided help" },
  { path: "/admin/suggestions", page: "Inbox, filters, export" },
  { path: "/admin/beta", page: "Beta testers + feedback table" },
  { path: "/admin/hub", page: "The Hub review — requests, listings, pause members" },
  { path: "/admin/hub/hall", page: "The Hub Convention Hall (admin)" },
  { path: "/admin/hub/:category", page: "The Hub rooms (admin)" },
  { path: "/admin/founders", page: "Founder’s View — Hub mission control (admin only)" },
  { path: "/admin/prospects", page: "Prospects (view only)" },
  { path: "/connect/:deskId", page: "Public prospect door (no account)" },
  { path: "Admin · Beta Onboarding Preview", page: "Opens Journey /beta in a new tab (not public)" },
  { path: "/admin/users", page: "Status, local password reset, login history" },
  { path: "/admin/accounts", page: "Account Management — onboard, billing, reports (admin only)" },
  { path: "/admin/accounts/:id", page: "Account Management · one desk" },
  { path: "/admin/controls", page: "Support articles, vendors, board, events, visibility" },
  { path: "/admin/sitemap", page: "This site map" },
  { path: "/admin/integrity", page: "Seven Walls of Steel — deployment integrity" },
];

export const CLIENT_MSG = ["/client/messages", "/client/messages/archive"];
